import React from "react";

export default (props) => (
  <th
    {...props}
    className={props.acoes ? "table-actions" : ""}
    style={{
      textAlign: props.alignright
        ? "right"
        : props.alignCenter
        ? "center"
        : "left",
      width: props.width || null,
      height: props.height || null,
      paddingLeft: 2,
      backgroundColor: props.backgroundColor || "#fff",
      position: "sticky",
      top: 0,
      color: props.color || "#000",
      paddingTop: props.paddingTop || 5,
      paddingBottom: props.paddingBottom || 5,
      paddingRight: props.paddingRight || 10,
      borderLeft: props.borderLeft,
      borderRight: props.borderRight,
      borderTop: props.borderTop,
      borderBottom: props.borderBottom,
      verticalAlign: "top",
    }}
  >
    {props.children}
  </th>
);
